<template>
  <div class="main-bottom">
    <p class="icon">
      <van-icon @click="returns" size="20px" name="cross" />
    </p>
    <h3 class="title">{{ $t("treasure_chest.title") }}</h3>
    <p :class="{ arrr: this.$i18n.locale == 'ar' }">
      {{ $t("treasure_chest.value1") }}
    </p>
    <p :class="{ arrr: this.$i18n.locale == 'ar' }">
      {{ $t("treasure_chest.value2") }}
    </p>
    <p :class="{ arrr: this.$i18n.locale == 'ar' }">
      {{ $t("treasure_chest.value3") }}
    </p>
    <p :class="{ arrr: this.$i18n.locale == 'ar' }">
      {{ $t("treasure_chest.value4") }}
    </p>
    <div style="margin-top: 20px">
      <div class="header">
        <div class="baoxiang-left"></div>
        <div class="baoxiang-title">
          <img src="../../assets/baoxiang/Rectangle 55.png" alt="" />
          <span>{{ $t("treasure_name.name1") }}</span>
        </div>
        <div class="baoxiang-right"></div>
      </div>

      <div class="baoxiang">
        <div
          class="baoxiang-box"
          v-for="item in muTreasureChest"
          :key="item.id"
        >
          <p class="color2">{{ item.name }}</p>
          <img :src="item.gurlPath" alt="" />
          <div v-if="item.type == 1" class="color3 h30px">{{ $t("baoxaingxianding") }}</div>
          <div v-else class="diamonds">
            <img src="../../assets/zs.svg" alt="" />
            <span class="color3">{{ item.cout }}</span>
          </div>
          <div class="color1">
            <p>{{ $t("treasure_name.name4") }}</p>
            <p>{{ item.probability / 1000 }}%</p>
          </div>
        </div>
      </div>
    </div>
    <p :class="{ arrr: this.$i18n.locale == 'ar' }">
      {{ $t("treasure_chest.value5") }}
    </p>

    <div style="margin-top: 20px">
      <div class="header">
        <div class="baoxiang-left"></div>
        <div class="baoxiang-title">
          <img src="../../assets/baoxiang/Rectangle 55(1).png" alt="" />
          <span> {{ $t("treasure_name.name2") }}</span>
        </div>
        <div class="baoxiang-right"></div>
      </div>

      <div class="baoxiang">
        <div
          class="baoxiang-box"
          v-for="item in yingTreasureChest"
          :key="item.id"
        >
          <p class="color2">{{ item.name }}</p>
          <img :src="item.gurlPath" alt="" />
          <div v-if="item.type == 1" class="color3 h30px">{{  $t("baoxaingxianding")  }}</div>
          <div v-else class="diamonds">
            <img src="../../assets/zs.svg" alt="" />
            <span class="color3">{{ item.cout }}</span>
          </div>
          <div class="color1">
            <p>{{ $t("treasure_name.name4") }}</p>
            <p>{{ item.probability / 1000 }}%</p>
          </div>
        </div>
      </div>
    </div>
    <p :class="{ arrr: this.$i18n.locale == 'ar' }">
      {{ $t("treasure_chest.value6") }}
    </p>
    <div style="margin-top: 20px">
      <div class="header">
        <div class="baoxiang-left"></div>
        <div class="baoxiang-title">
          <img src="../../assets/baoxiang/Rectangle 55(2).png" alt="" />
          <span>{{ $t("treasure_name.name3") }}</span>
        </div>
        <div class="baoxiang-right"></div>
      </div>

      <div class="baoxiang">
        <div
          class="baoxiang-box"
          v-for="item in jingTreasureChest"
          :key="item.id"
        >
          <p class="color2">{{ item.name }}</p>
          <img :src="item.gurlPath" alt="" />
          <div v-if="item.type == 1" class="color3 h30px">{{  $t("baoxaingxianding")  }}</div>
          <div v-else class="diamonds">
            <img src="../../assets/zs.svg" alt="" />
            <span class="color3">{{ item.cout }}</span>
          </div>
          <div class="color1">
            <p>{{ $t("treasure_name.name4") }}</p>
            <p>{{ item.probability / 1000 }}%</p>
          </div>
        </div>
      </div>
    </div>
    <p :class="{ arrr: this.$i18n.locale == 'ar' }">
      {{ $t("treasure_chest.value7") }}
    </p>
  </div>
</template>
<script>
import { Toast,Icon } from "vant";
export default {
  components:{
    VanIcon: Icon
  },
  data() {
    return {
      // token:
      //   "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1aWQiOiJOREV5IiwieHl6IjoiWmpsalpEUTVZakpqT0daaU5HTmlNV0ZpTnpWbFkyWmlNell3WmpnNVlqVT0iLCJleHAiOjE5MDc3NDM3NDB9.irA-gNwNYSD9s6_BQH2nwiQU8Zprq5BS2nyHhqwIRYY",
      // uid: 412,
      // headers: [
      //   "Content-Type:" + "application/json; charset=utf-8",
      //   "deviceId:" + "f9cd49b2c8fb4cb1ab75ecfb360f89b5",
      //   "lang:" + "zh_CN",
      //   "version:" + "1.0.2",
      //   "os:" + "3",
      //   "model:" + "M2011K2C",
      //   "fid:" + "0",
      // ],
      userInfo: [],
      token: null,
      uid: null,
      headers: null,
      muTreasureChest: null,
      yingTreasureChest: null,
      jingTreasureChest: null,
    };
  },
  created() {
    this.$completes.complete("getUserInfo");
    window.getUserInfo = this.getUserInfo;
    window["getUserInfo"] = (data) => {
      this.getUserInfo(data);
    };
    // this.getUserInfo();
  },
  mounted() {},
  methods: {
    //返回
    returns() {
      this.$completes.complete("getPreviousPage");
    },
    getUserInfo(data) {
      let that = this;
      this.userInfo = JSON.parse(data);
      this.headers = [
        "Content-Type:" + "application/json; charset=utf-8",
        "deviceId:" + JSON.parse(data).deviceId,
        "lang:" + JSON.parse(data).lang,
        "version:" + JSON.parse(data).version,
        "os:" + JSON.parse(data).os,
        "model:" + JSON.parse(data).model,
        "fid:" + JSON.parse(data).fid,
      ];
      this.token = JSON.parse(data).token;
      this.uid = JSON.parse(data).userId;
      let langs = this.userInfo.lang.substring(0, 2);
      let lang = this.userInfo.lang;
      
      // this.token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1aWQiOiJOemt6TVRVeSIsInh5eiI6IlEwWkRRakJCTURBdFJEYzJOaTAwTURZMkxUaEJRamd0UkVaR01rVXhSRFpCUWpjMSIsImV4cCI6MTk4ODc5MDUwMH0.5gf6hrAdwUQmmJsaL81bHIjK9DTu2stQcMcsK6Ikpq4';
      // this.uid = '793152'; 
      // this.headers = [
      //     "Content-Type:" + "application/json; charset=utf-8",
      //   "deviceId:" + 'CFCB0A00-D766-4066-8AB8-DFF2E1D6AB75',
      //   "lang:" + 'zh-CN',
      //   "version:" + '1.25.1',
      //   "os:" + '1',
      //   "fid:" + '2001',
      //   ]
      // let langs = 'en'
      // let lang = 'zh_CN'
      if (langs == "zh") {
        if (lang == "zh_TW" || lang == "zh_HK") {
          this.$i18n.locale = "tc";
        } else {
          this.$i18n.locale = "zh";
        }
      } else if (langs == "en") {
        this.$i18n.locale = "en";
      } else if (langs == "ar") {
        this.$i18n.locale = "ar";
      } else if (langs == "tr") {
        this.$i18n.locale = "tr";
      } else if (langs == "fr") {
        this.$i18n.locale = "fr"
      } else if (langs == "id") {
        this.$i18n.locale = "id"
      } else if (langs == "ms") {
        this.$i18n.locale = "ms"
      } else {
        this.$i18n.locale = "en";
      }
      document.title = this.$t("treasure_chest.title");
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
      // this.mubaoxaing()
      // this.yingbaoxiang()
      // this.jingbaoxiang()
    },

    mubaoxaing() {
      let that = this;
      let paramObjs = {
        option: "get",
        host:
          this.$serviceIp +
          "api/trade/gift/viewBaoxiang?token=" +
          that.token +
          "&uid=" +
          that.uid +
          "&baoxiangId=" +
          43015,
        data: "",
        header: JSON.stringify(this.headers),
      };
      this.$server.curlExec(paramObjs).then((data) => {
        data = data.data;
        if (data.code == 200) {
          console.log(data);
          this.muTreasureChest = data.data.items;
        } else {
          Toast(data.message || this.$t("transfer.error"));
        }
      });
    },

    yingbaoxiang() {
      let that = this;
      let paramObjs = {
        option: "get",
        host:
          this.$serviceIp +
          "api/trade/gift/viewBaoxiang?token=" +
          that.token +
          "&uid=" +
          that.uid +
          "&baoxiangId=" +
          43016,
        data: "",
        header: JSON.stringify(this.headers),
      };
      this.$server.curlExec(paramObjs).then((data) => {
        data = data.data;
        if (data.code == 200) {
          console.log(data);
          this.yingTreasureChest = data.data.items;
        } else {
          Toast(data.message || this.$t("transfer.error"));
        }
      });
    },

    jingbaoxiang() {
      let that = this;
      let paramObjs = {
        option: "get",
        host:
          this.$serviceIp +
          "api/trade/gift/viewBaoxiang?token=" +
          that.token +
          "&uid=" +
          that.uid +
          "&baoxiangId=" +
          43017,
        data: "",
        header: JSON.stringify(this.headers),
      };
      this.$server.curlExec(paramObjs).then((data) => {
        data = data.data;
        if (data.code == 200) {
          console.log(data);
          this.jingTreasureChest = data.data.items;
        } else {
          Toast(data.message || this.$t("transfer.error"));
        }
      });
    },
  },
};
</script>
  
<style>
* {
  margin: 0;
  padding: 0;
}

.main-bottom {
  height: 100%;
  width: 100%;
  padding: 10px 20px;
  color: #ffffff;
  background-color: #1e0f2e;
  position: fixed;
  bottom: 0px;
  box-sizing: border-box;
  overflow: auto;
}

.title {
  font-size: 18px;
  line-height: 40px;
  text-align: center;
}

.main-bottom p {
  font-size: 16px;
  line-height: 25px;
}

table.gridtable {
  width: 100%;
  font-family: verdana, arial, sans-serif;
  font-size: 11px;
  color: #333333;
  border-width: 1px;
  border-color: #666666;
  border-collapse: collapse;
}

table.gridtable th {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #666666;
  background-color: #dedede;
}

table.gridtable td {
  border-width: 1px;
  padding: 8px;
  text-align: right;
  border-style: solid;
  border-color: #666666;
  background-color: #ffffff;
}

.icon {
  text-align: right;
}
.arrr {
  direction: rtl;
  unicode-bidi: bidi-override;
}

.baoxiang-title {
  width: 36%;
  height: 36px;
  color: #efcb19;
  font-size: 14px;
  background-image: url(../../assets/baoxiang/Rectangle1001.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  /* justify-content: space-around; */
  padding-left: 7px;
  box-sizing: border-box;
}

.baoxiang-title img {
  width: 50px;
  height: 50px;
}
.baoxiang-left {
  width: 32%;
  height: 0px;
  opacity: 1;
  border: 1px solid;
  border-image: linear-gradient(
      160deg,
      rgba(241, 206, 23, 1),
      rgba(150, 31, 169, 0)
    )
    1 1;
}

.baoxiang-right {
  width: 32%;
  height: 0px;
  opacity: 1;
  border: 1px solid;
  border-image: linear-gradient(
      270deg,
      rgba(241, 206, 23, 1),
      rgba(150, 31, 169, 0)
    )
    1 1;
}

.header {
  display: flex;
  align-items: flex-end;
}

.baoxiang {
  font-size: 16px;
  color: #000;
  display: flex;
  justify-content: space-around;
  /* justify-content: center; */
  flex-wrap: wrap;
  margin-top: 10px;
}
.baoxiang-box {
  width: 31%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px 12px 0px 0px;
  background: linear-gradient(
    180deg,
    #1f162d 0%,
    rgba(56, 30, 65, 0.55) 46%,
    rgba(49, 1, 87, 0) 92%
  );
  opacity: 1;
  margin: 10px 0;
  padding: 5px 0;
}
.baoxiang-box img {
  width: 70px;
  height: 70px;
  margin: 5px 0;
}

.diamonds {
  display: flex;
  align-items: center;
}
.diamonds img {
  width: 20px;
  height: 20px;
}

.color1 {
  display: flex;
}
.color1 p {
  font-size: 12px !important;
  color: #c4c1c1;
}
.color2 {
  width: 100%;
  height: 50px;
  overflow: hidden;

  font-size: 14px !important;
  word-break: break-word;
  text-align: center;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #7b7483;
}

.color3 {
  color: #ea32d7;
}
.h30px{
  height: 30px;
  line-height: 30px;
  overflow: hidden;
}
</style>